<script>
import { useReveal } from '@site/composables/useReveal'
import { applySeo } from '@site/composables/useSeo'
import AppHeader from '@site/components/layout/AppHeader.vue'
import SiteFooter from '@site/components/layout/SiteFooter.vue'
import ConsultModal from '@site/components/layout/ConsultModal.vue'

export default {
  name: 'App',
  components: { AppHeader, SiteFooter, ConsultModal },
  data() {
    return { reveal: null }
  },
  created() {
    applySeo(this.$route)
    // ????????? reveal ??????????
    this._seoWatcher = this.$watch(
      () => this.$route.path,
      (path) => {
        const route = this.$route
        applySeo(route)
      }
    )
  },
  mounted() {
    const { init, destroy } = useReveal()
    this.reveal = { init, destroy }
    init()
  },
  beforeDestroy() {
    if (this.reveal) this.reveal.destroy()
    if (this._seoWatcher) this._seoWatcher()
  },
}
</script>

<template>
  <div class="app-shell hft-site">
    <AppHeader />
    <router-view />
    <SiteFooter />
    <ConsultModal />
  </div>
</template>

<style lang="scss">
@import '~@site/assets/styles/global.scss';
@import '~@site/assets/styles/_components.scss';
@import '~@site/assets/styles/_responsive.scss';
</style>



// WEBPACK FOOTER //
// src/site/App.vue